import React, { PureComponent } from "react";

import { withStyles } from "@material-ui/core/styles";

import TextField from "@material-ui/core/TextField";

import Title from "../../Title";

import LocaleContext from "../../../../i18n/LocaleContext";

import styles from "../styles";

class Financial extends PureComponent {
  static contextType = LocaleContext;

  render() {
    const {
      application,
      onApplicationTextChange,
      errors,
      classes
    } = this.props;
    const t = this.context;
    return (
      <div className={classes.root}>
        {application.isCheckout ? (
          <Title h2={"Where do you want your daily deposits?"} />
        ) : (
          <Title
            h1={t("Financial Info")}
            h2={t(
              "Please enter your financial information so we can deposit money into your account."
            )}
          />
        )}
        <div className={classes.sectionForm}>
          <div className={classes.inputContainer}>
            <TextField
              id="routingNumber"
              label={t("Routing Number")}
              placeholder="000000000"
              variant="outlined"
              className={classes.sideMargins}
              value={application.routingNumber || ""}
              onChange={onApplicationTextChange("routingNumber")}
              error={!!errors.routingNumber}
              helperText={errors.routingNumber}
              margin="normal"
              fullWidth
            />
            <TextField
              id="bankName"
              label={t("Bank Name")}
              variant="outlined"
              className={classes.sideMargins}
              value={application.bankName || ""}
              onChange={onApplicationTextChange("bankName")}
              error={!!errors.bankName}
              helperText={errors.bankName}
              margin="normal"
              fullWidth
            />
          </div>
          <div className={classes.inputContainer}>
            <TextField
              id="bankAccountNumber"
              label={t("Bank Account Number")}
              placeholder="000000000"
              variant="outlined"
              className={classes.sideMargins}
              value={application.bankAccountNumber || ""}
              onChange={onApplicationTextChange("bankAccountNumber")}
              error={!!errors.bankAccountNumber}
              helperText={errors.bankAccountNumber}
              margin="normal"
              fullWidth
            />
            <TextField
              id="confirmBankAccountNumber"
              label={t("Re-enter Bank Account Number")}
              placeholder="000000000"
              variant="outlined"
              className={classes.sideMargins}
              value={application.confirmBankAccountNumber || ""}
              onChange={onApplicationTextChange("confirmBankAccountNumber")}
              error={!!errors.confirmBankAccountNumber}
              helperText={errors.confirmBankAccountNumber}
              margin="normal"
              fullWidth
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Financial);
